import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: 'int', loadChildren: () => import('../401/internal/dsw401-dashboard.module').then(m => m.DSW401DashboardModule) },
    { path: 'ext', loadChildren: () => import('../401/external/dsw401-service-home.module').then(m => m.DSW401ServiceHomeModule) },
];
